import { giveProductsOf } from "./giveProductsOf";

export const giveProductsOfSunlight = giveProductsOf("sunlight");
